import * as o from "react";
import { c as t } from "../createReactComponent-58f9bea8.mjs";
import { b as e, r } from "../tooltip-cb602d1f.mjs";
import { T as f, a as g } from "../tooltip-cb602d1f.mjs";
import "../property-9daa16cd.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../class-map-2994e95e.mjs";
const n = t({ tagName: "ex-tooltip", elementClass: e, react: o, events: {}, displayName: "ExTooltip", registerWebComponent: r });
export {
  n as ExTooltip,
  f as TooltipAlignment,
  g as TooltipPosition,
  r as register
};
